import logoDark from "@/images/logo-dark.svg";
import logoLight from "@/images/logo-light.svg";
import { cn } from "@/lib/utils";

/** The wordmark, dark on light pages and light on dark ones. */
export const Logo = ({ className }) => (
  <span className={cn("inline-flex h-6 shrink-0", className)}>
    <img
      src={logoDark}
      alt="Simbiosis"
      width={128}
      height={21}
      className="h-full w-auto dark:hidden"
    />
    <img
      src={logoLight}
      alt="Simbiosis"
      width={128}
      height={21}
      className="hidden h-full w-auto dark:block"
    />
  </span>
);
